import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import toastr from "toastr";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: false,
  positionClass: "toast-top-full-width",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

/* Modules */
import auth from "./modules/auth";
import customer from "@/store/modules/customer.js";
import dealer from "./modules/dealer";
import decoration from "@/store/modules/projects/decoration.js";
import uploadLogos from "./modules/uploadLogos";

import actionsPermissions from "@/store/modules/projects/actionsPermissions.js";
import catalog from "@/store/modules/projects/catalog.js";
import project from "@/store/modules/projects/project.js";
import threekit from "@/store/modules/projects/threekit.js";
import playbook from "@/store/modules/projects/playbook.js";
import snapsheet from "@/store/modules/projects/snapsheet.js";
import showroom from "@/store/modules/projects/showroom.js";
import editableLogo from "@/store/modules/projects/editableLogo.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    actionsPermissions,
    auth,
    catalog,
    customer,
    dealer,
    decoration,
    playbook,
    project,
    uploadLogos,
    editableLogo,
    snapsheet,
    threekit,
    showroom,
  },

  state: {
    settings: {
      playbookEndpoint:
        process.env.VUE_APP_PLAYBOOK_ENDPOINT ||
        "https://fsg.playbook.axlot.com/",
      endpoint: process.env.VUE_APP_ENDPOINT,
      builder: process.env.VUE_APP_SHOWROOM_URL,
      showroomUrl: process.env.VUE_APP_SHOWROOM_URL,
      snapsheetEndpoint: process.env.VUE_APP_SNAPSHEET_URL,
      gameplanUrl: process.env.VUE_APP_GAMEPLAN_URL,
      fsajax: process.env.VUE_APP_FS_AJAX,
      validateGamePlanToken:
        process.env.VUE_APP_VALIDATE_GAMEPLAN_TOKEN.toLowerCase() === "true",
    },
    endpoint: process.env.VUE_APP_ENDPOINT,
    loading: true,
    active_page: "",
    snapsheetColorsIds: [
      5, 6, 7, 8, 10, 13, 14, 15, 16, 18, 19, 20, 21, 22, 23, 25,
    ],
  },

  getters: {
    getColorHexByField: (state) => (data) => {
      let color_id =
        !data.side || !data.subfield
          ? state[data.product_type + "_product"][data.field]
          : state[data.product_type + "_product"][data.side][data.field][
              data.subfield
            ];
      //let color = state.colors[color_id];
      for (let index = 0; index < state.colors.length; index++) {
        const element = state.colors[index];
        if (element.id === color_id) {
          return element.hex;
        }
      }
      return "#FFFFFF"; //White placeholder when data still didn't come from the API
    },
  },

  actions: {
    triggerStartLoading({ commit }) {
      commit("CHANGE_LOADING_STATE", true);
    },

    async triggerEndLoading({ commit }) {
      commit("CHANGE_LOADING_STATE", false);
    },

    setLoading({ commit }, loadingState) {
      commit("SET_LOADING", loadingState);
    },

    redirectToPage(_e, page) {
      let name = page.name;
      router.push({
        name: name,
      });
    },

    showToast(_e, msg) {
      let type = msg.type || "success";
      switch (type) {
        case "success": {
          toastr.success(msg.txt);
          break;
        }
        case "info": {
          toastr.info(msg.txt);
          break;
        }
        case "warning": {
          toastr.warning(msg.txt);
          break;
        }
        case "error": {
          toastr.error(msg.txt);
          break;
        }
      }
    },
  },

  mutations: {
    SET_LOADING: (state, loadingState) => {
      state.loading = loadingState;
    },
    CHANGE_LOADING_STATE: (state, bool) => (state.loading = bool),

    setActivePage: (state, page) => {
      state.active_page = page;
    },
    setLoading: (state, loadingState) => {
      state.loading = loadingState;
    },

    SET_SNAPSHEETS_TEMPLATES: (state, templatesData) =>
      (state.snapsheetsTemplates = templatesData),
  },
});
